<template>
  <div class="ckeditor-custom ck-content">
    <template
      v-if="!isDisabled"
    >
      <component
        :is="ckeditor"
        ref="ckEditor"
        :editor="editor"
        :disabled="isDisabled"
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
        :config="editorConfig"
        @ready="onEditorReady"
      />
    </template>
    <template v-else>
      <div class="content-editor">
        <div
          v-if="dangerouslyUseHtmlString"
          v-html="modelValue"
          class="test-text inline-block"
        />
        <div
          v-else
          v-text="modelValue"
          class="test-text inline-block"
        />
      </div>
    </template>
    <slot />
  </div>
</template>

<script>
import { configEditor } from './config.js'
import ClassicEditor from 'misa-editor'
import { shallowRef, defineAsyncComponent, ref } from 'vue'

export default {
  emits: ['update:modelValue', 'onEditorReady'],

  props: {
    modelValue: {
      type: String,
      default: ''
    },

    isDisabled: {
      type: Boolean,
      default: true
    },

    smallBlankBox: {
      type: Boolean,
      default: false
    },
    /**
     * Có dùng v-html không
     * dùng khi isDisabled=true
     */
    dangerouslyUseHtmlString: {
      type: Boolean,
      default: true
    }
  },

  computed: {

    editorConfig () {
      return configEditor
    },
    listContentValue () {
      // const s = '12367102361923129312<blank-box/>51254214321412421<blank-box/>41241212312<blank-box/>3123123123123123<blank-box/>423423423423423<blank-box/>432423423423423<blank-box/>2342343242343242<blank-box/>'

      return this.$commonFn.convertViewBlankBox(this.modelValue)
    }
  },

  watch: {
    modelValue: {
      handler () {
        this.queueTypeSetMathJax()
      },
      deep: true

    }
  },

  setup () {
    const editor = ref(ClassicEditor)
    const ckEditor = shallowRef(null)
    const ckeditor = shallowRef('div')
    return {
      editor,
      ckeditor,
      ckEditor
    }
  },

  async mounted () {
    const me = this

    if (!me.isDisabled) {
      me.ckeditor = defineAsyncComponent(() => {
        return new Promise((resolve, reject) => {
          import(/* webpackChunkName: "ckeditor" */ '@ckeditor/ckeditor5-vue').then(res => {
            resolve(res.component)
          })
        })
      })
    }
    me.queueTypeSetMathJax()
  },

  methods: {
    queueTypeSetMathJax () {
      const me = this

      if (me.isDisabled) {
        if (window.__contextData.timeoutVar) {
          clearTimeout(window.__contextData.timeoutVar)
        }
        const outputMathJax = window.MathJax.startup.output

        if (outputMathJax && typeof (outputMathJax.clearFontCache) === 'function') {
          outputMathJax.clearFontCache()
        }
        if (outputMathJax && typeof (outputMathJax.clearCache) === 'function') {
          outputMathJax.clearCache()
        }
        window.__contextData.timeoutVar = setTimeout(() => {
          window.MathJax.typeset()
        }, 300)
      }
    },

    onEditorReady () {
      this.$emit('onEditorReady')
      // emit(globalEvents.OnEditorViewerReady)
    },

    focusEditor () {
      this.ckEditor.$el.nextSibling.querySelector('.ck-editor__editable')?.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
.ckeditor-custom{
    display: inline-block;
    position: relative;
    --ck-color-base-background: transparent;
    --ck-color-base-border: transparent;
    :deep(.ck-editor){
        display: inline-block;
    }
    :deep(.ck-editor__editable){
        border: none;
        padding: 0;

        p {
          margin: 0;
        }
    }
    :deep(.ck-editor__top){
        display: none;
    }
}

</style>
<style lang="scss">
.ckeditor-custom{
  .ck-editor .ck-editor__main .ck-editor__editable.blank-box-edit
    {
      min-height: unset;
      border-radius: 10px;
    }

}

.disable-editor .blank-box{
  padding: 0px !important;
  margin: 0px 5px;
  height: 26px !important;
  width: 40px !important;
  border-radius: 8px !important;
}

.small-blank-box{
  display: flex;
  align-items: center;
}

.small-blank-box .blank-box{
  padding-top: 4px !important;
}

</style>
